const EXCLUDED_GENERAL_REQUESTS = [
	{ url: /^\/auth\/refresh/, status: 400 },
	{ url: /^\/geomap/, status: 403 },
	{ url: /^\/auth\/less/, status: 401 },
	{ url: /^\/orders\/.*\/process/, status: 403 },
	{ url: /^\/orders\/.*\/status/, status: 400 },
	{ url: /^\/users/, status: 400 },
	{ url: /^\/auth\/authenticated/, status: 401 },
	{ url: /^\/cash-book\/.*\/print/, status: 404 },
]

const EXCLUDED_FORBIDDEN_REQUESTS = [
	{ url: /^\/paypalNotification/, status: 403 },
	{ url: /^\/company\/tse\/notification/, status: 403 },
	{ url: /^\/driverIntegrations/, status: 403 },
]

const EXCLUDED_USER_FACING_REQUESTS = [
	/^\/auth\/refresh/,
]

const isRequestExcluded = (list, error) => {
	const { config, status } = error?.response || {}
	const url = config?.url

	if (!url || !status) return false

	return list.some(item => item.status === status && item.url.test(url))
}

export const filterError = (error) => {
	return !isRequestExcluded(EXCLUDED_GENERAL_REQUESTS, error)
}

export const shouldHandleForbiddenError = (error) => {
	return !isRequestExcluded(EXCLUDED_FORBIDDEN_REQUESTS, error)
}

export const shouldShowErrorToUser = (error) => {
	const url = error?.response?.config?.url || error?.config?.url

	if (!url) return true

	return !EXCLUDED_USER_FACING_REQUESTS.some(excludedUrl => excludedUrl.test(url))
}

